<template>
  <div class="pdf-container" id="questionId">
    <div @click="onPdf">导出</div>
    <!-- <section slot="pdf-content">
      <div class="pdf-item" v-for="(item, index) in list" :key="index">
        <div class="topic-section">
          <div class="topic" v-html="topicHtml(index, item.topic)"></div>
          <div class="subtitle" v-html="item.subtitle"></div>
        </div>
        <div class="option-section">
          <div
            class="option-item"
            v-for="(value, key) in item.option"
            :key="key"
            v-html="optionHtml(key, value)"
          ></div>
        </div>
        <div class="answer-section">
          【您的答案】
          <div class="answer" v-html="item.answer"></div>
        </div>
        <div class="answer-section padding-4">
          【参考答案】
          <div class="answer" v-html="item.answer"></div>
        </div>
        <div class="analysis-section">
          【解析】
          <div class="analysis" v-html="item.analysis"></div>
        </div>
        <div class="knowledge-section">
          【考点】
          <div class="knowledge">
            <span
              class="knowledge-text"
              v-for="v in item.knowledge"
              :key="v.id"
              >{{ v.name }}</span
            >
          </div>
        </div>
      </div>
    </section> -->
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="500"
      :filename="fileName"
      :pdf-quality="1"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    > -->
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="500"
      :filename="fileName"
      :pdf-quality="1"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div ref='questionSection' style="padding: 0 30px">
          <div class="pdf-item" v-for="(item, index) in list" :key="index" style="margin-bottom: 15px;">
            <div class="topic-section">
              <div class="topic" v-html="topicHtml(index, item.topic)"></div>
              <div class="subtitle" v-html="item.subtitle"></div>
            </div>
            <div class="option-section" style="padding: 4px 8px;">
              <div
                class="option-item"
                v-for="(value, key) in item.option"
                :key="key"
                v-html="optionHtml(key, value)"
              ></div>
            </div>
            <div class="answer-section">
              【您的答案】
              <div
                class="answer"
                v-html="item.answer"
                style="display: inline-block"
              ></div>
            </div>
            <div class="answer-section" style="padding: 4px 0;">
              【参考答案】
              <div
                class="answer"
                v-html="item.answer"
                style="display: inline-block"
              ></div>
            </div>
            <div class="analysis-section">
              【解析】
              <div class="analysis" v-html="item.analysis"></div>
            </div>
            <div class="knowledge-section" style="padding-top: 4px;">
              【考点】
              <div class="knowledge">
                <span
                  class="knowledge-text"
                  v-for="v in item.knowledge"
                  :key="v.id"
                  >{{ v.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf> -->
  </div>
</template>
<script>
import Vue from "vue";
// import VueHtml2pdf from "vue-html2pdf";
Vue.prototype.optionHtml = function(i, v) {
  // to do
  let html = ["A", "B", "C", "D"];
  return html[i] + "." + v;
};
Vue.prototype.topicHtml = function(i, v) {
  // to do
  return `【${i + 1}】` + "." + v;
};
export default {
  components: {
    // VueHtml2pdf,
  },
  data() {
    return {
      fileName: "错题本",
    };
  },
  props: {
    list: Array,
  },
  watch: {
    list: () => {
      this.mathJaxInit();
    },
  },
  created() {
    this.mathJaxInit();
  },
  methods: {
    onPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    mathJaxInit() {
      this.$nextTick(() => {
        //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
        if (this.commonsVariable.isMathjaxConfig) {
          //判断是否初始配置，若无则配置。
          this.commonsVariable.initMathjaxConfig();
        }
        this.commonsVariable.MathQueue("questionId"); //传入组件id，让组件被MathJax渲染
        console.log(this.$refs.questionSection.offsetHeight)
      });
    },
  },
};
</script>
<style scoped>
.pdf-container .pdf-item {
  margin-bottom: 15px;
}
.pdf-container .answer {
  display: inline-block;
}
.option-section {
  padding: 4px 8px;
}
.knowledge-section {
  padding-top: 4px;
}
.padding-4 {
  padding: 4px 0;
}
</style>
